'use client'

import type * as React from 'react'
import { useIsLoggedInQuery } from 'auth/hooks'

export function IsLoggedIn({
  children,
  hideIfLoggedIn = true,
  pendingFallback = null,
}: React.PropsWithChildren<{ hideIfLoggedIn?: boolean; pendingFallback?: React.ReactNode }>) {
  const authQuery = useIsLoggedInQuery()
  if (authQuery.isPending) {
    return pendingFallback
  }
  if (authQuery.isError) {
    return hideIfLoggedIn ? children : null
  }
  return Boolean(authQuery.data) === !hideIfLoggedIn ? children : null
}
